import { Box, Stack, Typography } from "@mui/material"

interface StepProgressProps {
    indiceAtivo: number
    total: number
    progressoAtual: number
    detalhe?: string
}

function StepProgress({ indiceAtivo, total, progressoAtual, detalhe }: StepProgressProps): JSX.Element {
    return (
        <Stack spacing={1}>
            <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700, letterSpacing: 1 }}>
                Passo {indiceAtivo + 1} de {total}{detalhe ? ` · ${detalhe}` : ''}
            </Typography>

            <Stack direction="row" spacing={1}>
                {Array.from({ length: total }, (_, i) => {
                    const preenchimento = i < indiceAtivo ? 1 : i === indiceAtivo ? progressoAtual : 0

                    return (
                        <Box
                            key={i}
                            sx={{
                                height: 6,
                                flex: 1,
                                borderRadius: 3,
                                overflow: 'hidden',
                                backgroundColor: 'action.hover',
                            }}
                        >
                            <Box
                                sx={{
                                    height: '100%',
                                    width: `${Math.round(preenchimento * 100)}%`,
                                    borderRadius: 3,
                                    backgroundColor: 'primary.main',
                                    transition: 'width 0.35s ease',
                                }}
                            />
                        </Box>
                    )
                })}
            </Stack>
        </Stack>
    )
}

export default StepProgress